import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  createStyles,
  makeStyles,
  Theme,
  useMediaQuery,
} from '@material-ui/core';
import { useTheme } from '@material-ui/styles';

import noop from '../../utility/noop';
import { useId } from '../../hooks';

type Props = {
  open: boolean;
  title?: React.ReactNode;
  text?: React.ReactNode;
  confirmText?: React.ReactNode;
  cancelText?: React.ReactNode;
  onClose?: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
};

const useStyles = makeStyles(({ colors }: Theme) => createStyles({
  modal: {
    border: `2px solid ${colors.border}`,
    '& button:focus': {
      background: 'rgba(255, 108, 0, 0.08)',
    },
  },
}));

const ModalConfirm = ({
  open,
  title = 'Confirm action',
  text = 'Do you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onClose = noop,
  onConfirm = noop,
  onCancel = noop,
}: Props) => {
  const theme = useTheme<Theme>();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const id = useId();
  const classes = useStyles();

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby={id}
      style={{ zIndex: 2147483100 }}
      PaperProps={{ className: classes.modal }}
    >
      <DialogTitle id={id}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {cancelText}
        </Button>
        <Button autoFocus onClick={onConfirm} color="primary">
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalConfirm;
